import React from 'react';

const footer = (props) => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <ul>
        <li><a href='https://www.cdphp.com/legal/non-discrimination' target='_blank' rel='noopener noreferrer'>Non-Discrimination</a></li>
        <li><a href='https://www.cdphp.com/legal/languages' target='_blank' rel='noopener noreferrer'>Languages</a></li>
        <li><a href='https://www.cdphp.com/legal/privacy-practices' target='_blank' rel='noopener noreferrer'>Privacy Practices</a></li>
        <li><a href='https://www.cdphp.com/legal/terms-of-use' target='_blank' rel='noopener noreferrer'>Terms of Use</a></li>
        <li><a href='https://www.cdphp.com/legal/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a></li>
      </ul>
      <div className='copyright'>
        <p>&copy;{currentYear} CDPHP&reg;. All Rights Reserved</p>
        <p>Capital District Physicians&rsquo; Health Plan, Inc.</p>
        <p>6 Wellness Way, Latham, NY 12110</p>
      </div>
      <div className='disc'>
        {props.medicare === 'true' ? <p><sup>&dagger;</sup>For more information on star ratings, visit www.medicare.gov.</p> : null}
        {props.smallbiz === 'true' ? <p>*NCQA Commercial Health Plan Ratings 2026</p> : null}
        {props.jdpower === 'true' ? <p>**For JD Power 2026 award information, visit jdpower.com/awards</p> : null}
        {props.medicareHours === 'true' ? <p><sup>&Dagger;</sup>Our hours are 8 a.m. – 8 p.m. seven days a week, October 1 – March 31. From April 1 to September 30, Monday – Friday, our hours are 8 a.m. to 8 p.m. A voice messaging service is used weekends, after-hours, and federal holidays.</p> : null}
        {props.medicareHours === 'true' ? <p>CDPHP is an HMO with a Medicare contract. Enrollment in CDPHP Medicare Advantage depends on contract renewal.</p> : null}
        {props.medicareHours === 'true' ? <p>Y0028_12544_M last updated 10/1/2026</p> : null}
        {props.results === 'true' ? <p>*<strong>Please note:</strong> This is an estimate and does not mean that you are eligible for these programs.<br />Only NY State of Health can determine your eligibility for Medicaid, Child Health Plus, the Essential Plan, and Qualified Health Plans.</p> : null}
      </div>
    </footer>
  );
};

export default footer;
